export default "__VITE_ASSET___dExijmz__"